import React from 'react';
import { useNavigate } from 'react-router-dom';
import { generateVideoUrl } from '../../utils/urlHelper';

const VideoCard = ({ video }) => {
    const navigate = useNavigate();

    const openVideo = () => {
        navigate(generateVideoUrl(video));
    };

    const formatDuration = (duration) => {
        if (!duration) return '—';
        if (duration.includes(':')) return duration;
        const mins = Math.floor(parseInt(duration) / 60);
        const secs = parseInt(duration) % 60;
        return `${mins}:${secs.toString().padStart(2, '0')}`;
    };

    return (
        <div className="video-card" onClick={openVideo}>
            <div style={{ position: 'relative' }}>
                <img
                    src={video.thumb || video.thumbData || 'https://via.placeholder.com/400x225'}
                    alt={video.title}
                    onError={(e) => e.target.src = 'https://via.placeholder.com/400x225?text=No+Image'}
                />
                <div className="play">▶</div>
                {video.dur && (
                    <div style={{
                        position: 'absolute',
                        bottom: '8px',
                        right: '8px',
                        background: 'rgba(0,0,0,0.7)',
                        color: '#fff',
                        padding: '2px 6px',
                        borderRadius: '4px',
                        fontSize: '11px'
                    }}>
                        {formatDuration(video.dur)}
                    </div>
                )}
            </div>
            <div className="info">
                <span className="tag orange" style={{ fontSize: '10px' }}>{video.category}</span>
                <h5>{video.title}</h5>
                <div style={{ fontSize: '11px', color: '#888', marginTop: '5px' }}>
                    👁️ {video.views?.toLocaleString() || 0} views
                </div>
            </div>
        </div>
    );
};

export default VideoCard;